import styled from 'styled-components';

import { media, themed } from '@/shared/ui/core';

export const ShiftListStyled = styled.div`
    width: 100%;
    max-width: 35.25rem;

  >.Title {
    font-size: 1.5rem;
    color: ${themed('primary.accent')};
    margin-bottom: 1rem;
  }

  @media ${media.tabletMin} {
    max-width: 46.875rem;
    display: flex;
    flex-direction: column;
  }

  @media ${media.dektopMin} {
    max-width: 57.5rem;
    display: flex;
    flex-direction: column;
  }
`;

export const List = styled.ul.attrs({
  className: 'ShiftList',
})`
  padding: 0;
  margin: 0;
  list-style: none;

  li + li {
    margin-top: 1.25rem;

  }
`;

export const ListFooter = styled.div.attrs({
  className: 'ListFooter',
})`

`;

export const ListActions = styled.div.attrs({
  className: 'ListActions',
})`
  .component__button {
    font-weight: 600;
    color: ${themed('status.info.main')};
  }
`;
